import { Box, RadioGroupField, Text } from '@medely/ui-kit';
import { HelpCenterLink } from '@mp/components/helpCenterLink';
import React from 'react';

const OPTIONS = [
  { label: 'Yes, I’m interested in W-2 shifts', value: 1 },
  { label: 'No, I’m not interested', value: 2 },
];

export const W2InterestFormFields = () => {
  return (
    <>
      <Box pb={2}>
        <Text size="l">
          This can increase the number of available shifts, but may include some additional
          onboarding steps and tax implications.{' '}
          <HelpCenterLink configKey="w2Shifts" text="Learn more" />
        </Text>
      </Box>
      <RadioGroupField name="w2_interest" options={OPTIONS} label={''} />
    </>
  );
};
